import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const VEHICLE_BY_UUID_RESOURCE = "vehicle" as const;
export const VEHICLE_BY_UUID_API_PATH = `/v1/${VEHICLE_BY_UUID_RESOURCE}/{uuid}` as const;

export type VehicleByUuidParameters = paths[typeof VEHICLE_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type VehicleByUuidResponse =
  paths[typeof VEHICLE_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleByUuidQuery(uuid: string, options?: Options<VehicleByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<VehicleByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    queryKey: [VEHICLE_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<VehicleByUuidResponse>(`/v1/${VEHICLE_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
    enabled: !!uuid,
  });
}
